import { render } from "./LookupFiltersView.vue?vue&type=template&id=1dd9cb5f&ts=true"
import script from "./LookupFiltersView.vue?vue&type=script&lang=ts"
export * from "./LookupFiltersView.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__